import { Controller } from "@hotwired/stimulus"

// Controller: supports role, employee (named person), auto, site-Bauleiter,
// Standortleiter and deputy-chain (Stellvertretung) approval types
export default class extends Controller {
  static targets = [
    "approverType",
    "roleConfig",
    "autoConfig",
    "employeeConfig",
    "siteBauleiterConfig",
    "locationLeaderConfig",
    "deputyConfig",
  ]

  connect() {
    this.updateApproverConfig()
  }

  updateApproverConfig() {
    const selectedType = this.approverTypeTarget.value

    // Hide all config sections
    this.hideAllConfigs()

    // Show the relevant config section
    switch (selectedType) {
      case "role":
        if (this.hasRoleConfigTarget) this.showConfig(this.roleConfigTarget)
        break
      case "employee":
        if (this.hasEmployeeConfigTarget) this.showConfig(this.employeeConfigTarget)
        break
      case "auto":
        if (this.hasAutoConfigTarget) this.showConfig(this.autoConfigTarget)
        break
      case "site_bauleiter":
        if (this.hasSiteBauleiterConfigTarget) this.showConfig(this.siteBauleiterConfigTarget)
        break
      case "location_leader":
        if (this.hasLocationLeaderConfigTarget) this.showConfig(this.locationLeaderConfigTarget)
        break
      case "deputy":
        if (this.hasDeputyConfigTarget) this.showConfig(this.deputyConfigTarget)
        break
    }
  }

  hideAllConfigs() {
    if (this.hasRoleConfigTarget) this.hideConfig(this.roleConfigTarget)
    if (this.hasAutoConfigTarget) this.hideConfig(this.autoConfigTarget)
    if (this.hasEmployeeConfigTarget) this.hideConfig(this.employeeConfigTarget)
    if (this.hasSiteBauleiterConfigTarget) this.hideConfig(this.siteBauleiterConfigTarget)
    if (this.hasLocationLeaderConfigTarget) this.hideConfig(this.locationLeaderConfigTarget)
    if (this.hasDeputyConfigTarget) this.hideConfig(this.deputyConfigTarget)
  }

  showConfig(target) {
    target.classList.remove("hidden")
    this.setInputsDisabled(target, false)
  }

  // Hidden blocks must not submit: several blocks share field names (e.g.
  // settings[include_pending_absences], settings[employee_ids][]), and with all
  // blocks in the DOM the last one wins over the visible block's value.
  hideConfig(target) {
    target.classList.add("hidden")
    this.setInputsDisabled(target, true)
  }

  setInputsDisabled(target, disabled) {
    target.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = disabled
    })
  }
}
